<template>
  <div id="app"  >
    <Spin fix v-if="$store.state.LOADING">
      <img src="./assets/logo.svg" alt="" class="loading">
      <div>加载中...</div>
    </Spin>
    <router-view></router-view>

  </div>
</template>

<script>
  import {mapState} from "vuex";
  export default {
    name: 'App',
    data() {
      return {
        id: '',
      }
    },
    created() {
    },
    computed: {
      ...mapState(["LOADING"]),
    },
    methods: {
    }
//   mounted() {
//     window.addEventListener('offline', ()=>{
//      // 网络由正常常到异常时触发
//      sessionStorage.locationUrl=window.location.href;
//      this.$router.replace('noNetwork')
//     });
//     window.addEventListener('online',()=>{
//       window.location.href=sessionStorage.locationUrl
//     });
//   },

  };
</script>

<style lang="scss">
@import "components/app";
  .loading{
    width: 50px;
    padding-bottom: 15px;
    animation: rotate 1s linear infinite;
  }
  @keyframes rotate {
    from{
      transform: rotateZ(0);
    }
    to{
      transform: rotateZ(360deg);
    }
  }
</style>
